<template lang="html">
  <div class="product-container flex spaced column">
    <div class="top-img">
      <div class="overlay overblue"></div>
      <img src="../assets/images/product/product_main.png" alt="">
    </div>
    <div class="content-top text-white row">
      <div class="page-title--norm content-padded">
        The all-in-one <br class="desktop-only">payment solution <br class="desktop-only">to increase efficiency
      </div>
      <div class="flex wrap content-slim--desktop">
        <div class="content-padded content-mintext equal-width">
          Pesaflow is a simple and reliable way to collect payments. Regardless of scale, Pesaflow offers powerful solutions across the board.
        </div>
        <div class="content-padded content-mintext equal-width">
          Pesaflow serves governments, organizations, institutions, non-profits, corporations, businesses- basically any establishment that has
          to receive payments and make settlements.
        </div>
      </div>
    </div>
    <div class="dark-blue text-white row flex column">
      <div class="content-margin content-padded content-maintext">
        Transform how payments and settlements are processed.
      </div>
      <div class="tab-container">
        <vue-tabs active-text-color="white" type="pills" v-bind="this.direction" active-tab-color="transparent" ref="tabs">
          <v-tab>
            <div slot="title" class="tab-title flex">
              <div class="title-head desktop-only">
                <img src="../assets/images/product/Ellipse 31.svg" alt="" slot="title">
              </div>
              <!-- <div class="mobile-only center-content tab-scroll--left" @click="changeTabs(0)">
                <<
              </div> -->
              <div class="content-subtext title-desc">
                <div class="bolded tab-padding">
                  Manage Invoices
                </div>
                <div class="tab-text">
                  Create invoices manually, view invoice status and retry payments for invoices in case payments made don’t reflect.
                </div>
              </div>
              <!-- <div class="mobile-only center-content tab-scroll--right" @click="changeTabs(1)">
                >>
              </div> -->
            </div>
            <div class="">
              <div class="stats-img">
                <img src="../assets/images/product/prodpage_6.png" alt="">
              </div>
            </div>
          </v-tab>

          <v-tab>
            <div slot="title" class="tab-title flex">
              <div class="title-head desktop-only">
                <img src="../assets/images/product/Ellipse 31.svg" alt="" slot="title">
              </div>
              <div class="content-subtext title-desc">
                <div class="bolded tab-padding">
                  Aggregate Payments
                </div>
                <div class="tab-text">
                  View payments from different channels in one interface.
                </div>
              </div>
            </div>
            <div class="">
              <div class="stats-img">
                <img src="../assets/images/product/prodpage_6.png" alt="">
              </div>
            </div>
          </v-tab>

          <v-tab>
            <div slot="title" class="tab-title flex">
              <div class="title-head desktop-only">
                <img src="../assets/images/product/Ellipse 31.svg" alt="" slot="title">
              </div>
              <div class="content-subtext title-desc">
                <div class="bolded tab-padding">
                  Make Settlements
                </div>
                <div class="tab-text">
                  Move your money from your Pesaflow account to your actual bank account.
                </div>
              </div>
            </div>
            <div class="">
              <div class="stats-img">
                <img src="../assets/images/product/prodpage_6.png" alt="">
              </div>
            </div>
          </v-tab>
        </vue-tabs>
      </div>
    </div>
    <div class="row content-spaced text-blue white">
      <div class="content-margin">
        <div class="content-padded content-maintext">
          A singular payment gateway with advanced features to boost performance.
        </div>
        <div class="flex wrap">
          <div class="stats-img flex">
            <img src="../assets/images/product/prodpage_1.png" alt="">
          </div>
          <div class="stats-text center-content column">
            <div class="content-padded content-subtitle">
              View transactions in realtime
            </div>
            <div class="content-padded content-subtext">
              View incoming payments. All transactions are linked to invoices.
            </div>
          </div>
        </div>
        <div class="flex wrap reverse">
          <div class="stats-img flex">
            <img src="../assets/images/product/prodpage_2.png" alt="">
          </div>
          <div class="stats-text center-content column vertical-center flex">
            <div class="content-padded content-subtitle">
              Complete control through approvals
            </div>
            <div class="content-padded content-subtext">
              Your account is secured as some actions require approval from a second person
              (maker- checker). Roles and permissions are approved by a central admin to safeguard the system.
            </div>
          </div>
        </div>
        <div class="flex wrap">
          <div class="stats-img flex">
            <img src="../assets/images/product/prodpage_3.png" alt="">
          </div>
          <div class="stats-text center-content column vertical-center flex">
            <div class="content-padded content-subtitle">
              Direct to bank account Settlements
            </div>
            <div class="content-padded content-subtext">
              Move money from your holding account to the services Pesaflow account and from the Pesaflow account to your bank account.
            </div>
          </div>
        </div>
        <div class="flex wrap reverse">
          <div class="stats-img flex">
            <img src="../assets/images/product/prodpage_4.png" alt="">
          </div>
          <div class="stats-text center-content column vertical-center flex">
            <div class="content-padded content-subtitle">
              Access comprehensive reports
            </div>
            <div class="content-padded content-subtext">
              View your reports daily, weekly, monthly and get to know specific details like amount of revenue streaming in at a specific time.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row content-spaced text-blue light-blue">
      <div class="content-padded content-maintext content-margin">
        Pesaflow guarantees transparency and traceability over all transactions.
      </div>
      <div class="">
        <div class="stats-img">
          <img src="../assets/images/product/prodpage_5.png" alt="">
        </div>
        <div class="flex wrap spaced visualizer">
          <div class="flex content-maintext content-padded">
            Visualize everything
          </div>
          <div class="column flex">
            <div class="content-subtitle content-margin equal-width">
              View dashboards and analytics
            </div>
            <div class="content-subtext equal-width">
              View your analytics, compare reports and derive conclusions from it.
            </div>
          </div>
        </div>
      </div>
      <div class="">
        <div class="stats-img">
          <img src="../assets/images/product/prodpage_5.png" alt="">
        </div>
        <div class="flex wrap spaced visualizer">
          <div class="flex content-maintext content-padded">
            Centralized control
          </div>
          <div class="column flex">
            <div class="content-subtitle content-margin equal-width">
              Manage all users in one place
            </div>
            <div class="content-subtext equal-width">
              Organization admin accesses the system, adds users and <br class="desktop-only">gives permissions to specific people.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row content-spaced text-blue content-margin">
      <div class="content-subtitle content-padded">
        Security
      </div>
      <div class="content-padded content-maintext">
        Data security is core to Pesaflow, with vital measures in place to safeguard all information.
      </div>
      <div class="flex wrap">
        <div class="column third-width flex">
          <div class="content-subtitle content-padded">
            Data <br class="desktop-only">encryption
          </div>
          <div class="content-subtext content-padded">
            After a client sends a bill, Pesaflow generates an invoice and sends it back with an invoice number against
            which the payment is made. This communication is encrypted using a client key and a secret pair.
          </div>
        </div>
        <div class="column third-width flex">
          <div class="content-subtitle content-padded">
            Authentication and <br class="desktop-only">session management
          </div>
          <div class="content-subtext content-padded">
            Enables the user to log in and out, and prompts automatic logout when a session is idle.
          </div>
        </div>
        <div class="column third-width flex">
          <div class="content-subtitle content-padded">
            Activity monitoring <br class="desktop-only">and testing
          </div>
          <div class="content-subtext content-padded">
            The system maintains an audit trail for each organization to see payment activity.
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="back-img">
        <div class="overlay dark-blue"></div>
        <img src="../assets/images/gov/govpage_1.png" alt="">
      </div>
      <div class="row text-white container content-margin">
        <div class="content-padded content-subtitle">
          The Technology
        </div>
        <div class="content-maintext content-padded">
          Fast evolving technology and increasing volumes of data present new challenges for governments. Pesaflow is equipped to perform at scale.
        </div>
        <div class="wrap flex">
          <div class="flex third-width column">
            <div class="content-padded">
              <img src="../assets/images/gov/govpage_2.svg" alt="" class="stats-img">
            </div>
            <div class="content-subtitle content-padded">
              Machine learning
            </div>
            <div class="content-padded content-subtext">
              Powered by machine learning, Pesaflow provides an intelligent financial system that can learn user trends and offer insights for improving service delivery.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-padded">
              <img src="../assets/images/gov/govpage_3.svg" alt="" class="stats-img">
            </div>
            <div class="content-subtitle content-padded">
              Big data
            </div>
            <div class="content-padded content-subtext">
              In an increasingly digital world, staggering volumes of data are generated. Pesaflow ensures a high level of data quality and
              accessibility for intelligence and big data analytics applications while guaranteeing interoperability and data security.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-padded">
              <img src="../assets/images/gov/govpage_4.svg" alt="" class="stats-img">
            </div>
            <div class="content-subtitle content-padded">
              Distributed system
            </div>
            <div class="content-padded content-subtext">
              Pesaflow is built to leverage horizontal scaling, taking advantage of cloud infrastructure or large clustered data centres.
               This allows it to handle exponential growth in user base.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="back-img med-blue">
        <img src="../assets/images/home/homepage_7.png" alt="">
      </div>
      <div class="row content-margin flex wrap spaced container">
        <div class="content-padded content-maintext">
          Scale your business or <br class="desktop-only"/>organization by tapping into <br class="desktop-only"/>
          the same powerful tools <br class="desktop-only"/>trusted by governments.
        </div>
        <div class="content-padded vertical-center flex">
          <button type="button" name="button" class="dark-blue text-white talk-btn">Talk to us today</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueTabs, VTab } from 'vue-nav-tabs';
/* eslint max-len: 0 */
export default {
  name: 'Products',
  components: {
    VueTabs,
    VTab,
  },
  data() {
    return {
      direction: { direction: 'vertical' },
    };
  },
  methods: {
    changeTabs(n) {
      this.$refs.tabs.navigateToTab(n);
    },
  },
  mounted() {
    if (window.innerWidth < 1024) {
      this.direction = '';
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../node_modules/vue-nav-tabs/themes/vue-tabs.css';


.top-img {
  img {
    object-position: -550px center;
  }
}
.content-top {
  min-height: 81vh;
}
.stats-img {
  img {
    width: 100%;
  }
}
.content-subtitle {
  align-self: flex-start;
}
.tab-scroll--left {
  margin-left: -20px;
  padding-right: 10px
}
.tab-scroll--right {
  margin-right: -20px;
  padding-left: 10px
}
@media only screen and (min-width: 1024px) {
  .tab-title {
    justify-content: space-between;
    .title-head {
      flex: 1;
      padding: 5px 0px;
      align-items: flex-start;
    }
    .title-desc {
      flex: 4;
      .tab-padding {
        padding-bottom: 10%;
      }
    }
  }
  .tab-text {
    max-height: 0px;
    overflow: hidden;
    transition: max-height 1s ease-in-out;
  }
  .active_tab .tab-text {
    max-height: 200px;
  }
  .content-top {
    min-height: 68vh;
  }
  .top-img {
    img {
      object-position: center center;
    }
  }
  .stats-img {
    flex: 2;
  }
  .stats-text {
    display: flex;
    flex: 1;
    align-items: flex-start;
  }
  .reverse {
    flex-direction: row-reverse;
  }
  .visualizer {
    padding: 0px 5%;
    .column {
      justify-content: flex-end;
    }
  }
}
</style>
